import { render, staticRenderFns } from "./autocomplete-company-recruitments.vue?vue&type=template&id=72a61dbf"
import script from "./autocomplete-company-recruitments.vue?vue&type=script&lang=js"
export * from "./autocomplete-company-recruitments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports